import { useEffect, useState } from "react";

const remainingSeconds = (expiresAt: number) =>
  Math.max(0, Math.round((expiresAt - Date.now()) / 1000));

export const useCountdown = (expiresAt: number): number => {
  const [secondsLeft, setSecondsLeft] = useState(() =>
    expiresAt ? remainingSeconds(expiresAt) : 0,
  );

  useEffect(() => {
    if (!expiresAt) {
      setSecondsLeft(0);
      return;
    }

    setSecondsLeft(remainingSeconds(expiresAt));
    const id = setInterval(() => setSecondsLeft(remainingSeconds(expiresAt)), 1000);
    return () => clearInterval(id);
  }, [expiresAt]);

  return secondsLeft;
};
